import { lazy } from 'react';

const LazyMainSettings = lazy(() => import('./main-settings'));
export default LazyMainSettings;
